import React from "react";
import { Box } from "@chakra-ui/react";

export interface TabItem {
  id: string;
  label: string;
  payload?: any;
}

export interface MobileTabsProps {
  tabs: TabItem[];
  selectedIndex: number;
  onTabChange: (index: number) => void;
  variant?: "grid" | "flex";
  className?: string;
}

const MobileTabs: React.FC<MobileTabsProps> = ({
  tabs,
  selectedIndex,
  onTabChange,
  variant = "grid",
  className,
}) => {
  const renderGridTabs = () => (
    <Box
      display="grid"
      gridTemplateColumns="1fr 1fr"
      gap="12px"
      mb={4}
      p={2}
      bg="#EFF1F3"
      className={className}
    >
      {tabs?.map((tab, idx) => (
        <Box
          key={tab.id}
          onClick={() => onTabChange(idx)}
          bg={selectedIndex === idx ? "white" : "transparent"}
          color={selectedIndex === idx ? "#1819B4" : "#2F2F34"}
          border={selectedIndex === idx ? "0.5px solid #A7B2BA" : "none"}
          boxShadow={
            selectedIndex === idx ? "0px 1px 4px 0px #0000001F" : "none"
          }
          borderRadius="10px"
          py={3}
          px={4}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontWeight="600"
          fontSize="14px"
          transition="all 0.2s"
          _hover={{ opacity: 0.8 }}
          _active={{ transform: "scale(0.98)" }}
          cursor="pointer"
        >
          {tab.label}
        </Box>
      ))}
    </Box>
  );

  const renderFlexTabs = () => (
    <Box
      display="flex"
      flexWrap="wrap"
      gap="8px"
      mb={4}
      bg="#F7F8FA"
      borderRadius="12px"
      className={className}
    >
      {tabs?.map((tab, idx) => (
        <Box
          key={tab.id}
          onClick={() => onTabChange(idx)}
          bg={selectedIndex === idx ? "#1819B4" : "white"}
          color={selectedIndex === idx ? "white" : "#2F2F34"}
          border="1px solid #E6E9EF"
          borderRadius="19px"
          padding="8px 16px"
          m="4px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontWeight="600"
          fontSize="16px"
          transition="all 0.2s"
          cursor="pointer"
          minH="48px"
          _hover={{
            opacity: selectedIndex === idx ? 0.9 : 0.8,
          }}
          _active={{ transform: "scale(0.98)" }}
          boxShadow={
            selectedIndex === idx
              ? "0px 2px 8px rgba(24, 25, 180, 0.2)"
              : "0px 1px 3px rgba(0, 0, 0, 0.1)"
          }
        >
          {tab.label}
        </Box>
      ))}
    </Box>
  );

  return variant === "grid" ? renderGridTabs() : renderFlexTabs();
};

export default MobileTabs;
